import React from "react";

const KPI_ITEMS = [
  {
    id: "dntt",
    title: "Đề nghị thanh toán",
    subtitle: "Phiếu chờ bạn duyệt",
    count: "565",
    statusText: "chờ duyệt",
    iconBg: "bg-emerald-50 text-emerald-600 border-emerald-100",
    numberColor: "text-gray-900",
    svg: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    id: "dntu",
    title: "Thanh toán có tạm ứng",
    subtitle: "Phiếu chờ bạn duyệt",
    count: "43",
    statusText: "chờ duyệt",
    iconBg: "bg-blue-50 text-blue-600 border-blue-100",
    numberColor: "text-gray-900",
    svg: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
    ),
  },
  {
    id: "dxnv",
    title: "Đề xuất nghiệp vụ",
    subtitle: "Phiếu chờ bạn duyệt",
    count: "2",
    statusText: "chờ duyệt",
    iconBg: "bg-purple-50 text-purple-600 border-purple-100",
    numberColor: "text-gray-900",
    svg: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: "trich_truoc",
    title: "Trích trước chi phí",
    subtitle: "Phiếu chờ bạn duyệt",
    count: "4",
    statusText: "chờ duyệt",
    iconBg: "bg-amber-50 text-amber-600 border-amber-100",
    numberColor: "text-amber-700",
    svg: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
  },
  {
    id: "lich_chi",
    title: "Lịch chi",
    subtitle: "Phiếu chờ bạn duyệt",
    count: "1788",
    statusText: "chờ duyệt",
    iconBg: "bg-pink-50 text-pink-600 border-pink-100",
    numberColor: "text-gray-900",
    svg: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: "phieu_chi",
    title: "Phiếu chi",
    subtitle: "Phiếu chờ bạn duyệt",
    count: "26",
    statusText: "chờ duyệt",
    iconBg: "bg-teal-50 text-teal-600 border-teal-100",
    numberColor: "text-gray-900",
    svg: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    id: "phieu_thu",
    title: "Phiếu thu",
    subtitle: "Phiếu chờ bạn duyệt",
    count: "3935",
    statusText: "chờ duyệt",
    iconBg: "bg-sky-50 text-sky-600 border-sky-100",
    numberColor: "text-gray-900",
    svg: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
];

export default function KpiCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4">
      {KPI_ITEMS.map((item) => (
        <div
          key={item.id}
          className="bg-white rounded-xl p-4 shadow-sm border border-gray-200/80 hover:shadow-md transition-all duration-200 flex flex-col justify-between group cursor-pointer"
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-center gap-3">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center border shadow-xs transition-transform group-hover:scale-105 ${item.iconBg}`}
              >
                {item.svg}
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-800 leading-tight group-hover:text-blue-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-gray-400 mt-0.5">{item.subtitle}</p>
              </div>
            </div>
          </div>

          <div className="mt-4 flex items-baseline justify-between pt-2 border-t border-gray-50">
            <span className={`text-2xl font-extrabold tracking-tight ${item.numberColor}`}>
              {item.count}
            </span>
            <span className="text-[11px] font-semibold text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
              {item.statusText}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
